import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

export default function FormAddEditBranch(props) {
    const { triggerSubmit, setTriggerSubmit, onCloseModal, updateItem,
        onSubmitAddEdit } = props;
    const buttonSubmitRef = useRef(null);

    const [checkActive, setCheckActive] = useState(true);
    useEffect(() => {
        setCheckActive(updateItem?.isActived ?? true);
        setValue("name", updateItem?.name || "");
        setValue("description", updateItem?.description || "");
    }, [])

    const { register, handleSubmit, errors, setValue } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    const onSubmit = (data) => {
        if (!data) {
            return;
        }

        onSubmitAddEdit({ ...data, id: updateItem?.id, isActived: checkActive });
        onCloseModal();
    }

    useEffect(() => {
        if (!triggerSubmit) return;
        buttonSubmitRef.current.click();
        setTriggerSubmit(false);
    }, [triggerSubmit])

    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-md-12">
                    <label>Tên chi hội <span className='required'>*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        name="name"
                        defaultValue={updateItem?.name}
                        maxLength="150"
                        placeholder="Nhập tên chi hội"
                        ref={register({ required: true, maxLength: 150 })}
                    />
                    {errors.name && errors.name.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                    {errors.name && (errors.name.type === "maxLength") && (
                        <span className="error">Độ dài không vượt quá 150 ký tự</span>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-12">
                    <label>Mô tả</label>
                    <textarea
                        className="form-control"
                        name="description"
                        defaultValue={updateItem?.description}
                        maxLength="500"
                        placeholder="Mô tả"
                        rows="3"
                        ref={register({ maxLength: 500 })}
                    />
                    {errors.description && (errors.description.type === "maxLength") && (
                        <span className="error">Độ dài không vượt quá 500 ký tự</span>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-12">
                    <label>Trạng thái hoạt động</label>
                    <div className="switch-button switch-button-yesno ml-5">
                        <input
                            type="checkbox"
                            checked={checkActive}
                            name="isActived"
                            id="isActived"
                            ref={register()}
                            onChange={() => setCheckActive(prev => !prev)}
                        />
                        <span><label htmlFor="isActived"></label></span>
                    </div>
                </div>
            </div>

            <button ref={buttonSubmitRef} style={{ display: "none" }} type="submit" className="btn btn-primary">
                Lưu
            </button>
        </form>
    )
}
